// @flow

export const FILTER_CARD_REPLACEMENT_STATUS = 'cardReplacementStatus'
export const FILTER_ENGRAVED_ID = 'engravedId'
export const FILTER_CARD_HOLDER_DETAILS = 'cardHolderDetails'
export const FILTER_COMBINED_ASCRIPTIONS = 'combinedAscriptions'
export const FILTER_VALID_UNTIL = 'validUntil'

export type CompanyCardsFilter = {
  cardReplacementStatus: string,
  engravedId: string,
  cardHolderDetails: string,
  combinedAscriptions: string,
  validUntil: string,
}

const buildCompanyCardsFilter = (): CompanyCardsFilter => {
  return {
    [FILTER_CARD_REPLACEMENT_STATUS]: 'onlyActive',
    [FILTER_ENGRAVED_ID]: '3528',
    [FILTER_CARD_HOLDER_DETAILS]: '',
    [FILTER_COMBINED_ASCRIPTIONS]: '',
    [FILTER_VALID_UNTIL]: ''
  }
}

export {
  buildCompanyCardsFilter
}



// WEBPACK FOOTER //
// ./src/types/company-cards-filter.js